var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-fit items-center space-x-4 rounded-md border px-4 py-2 font-medium shadow-md",class:_vm.cardClass},[_c(_vm.icon,{tag:"component",staticClass:"h-6 w-6 shrink-0 fill-current",class:_vm.iconClass}),_c('div',{class:_vm.messageClass},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }